// PIE CHART ANIMATION
const circumference = 2 * Math.PI * 45;

function initChart(circleChart) {
    const circle = circleChart.querySelector('.pie-chart-progress');
    const label = circleChart.querySelector('.pie-chart-label');
    const percentage = Math.min(100, Math.max(0, Number.parseFloat(circleChart.dataset.percent) || 0));

    // Reset to empty state
    circle.style.transition = 'none';
    circle.style.strokeDashoffset = circumference;
    label.textContent = '0%';

    function setProgress(p, animated) {
        const offset = circumference * (1 - p / 100);
        circle.style.transition = animated ? 'stroke-dashoffset 1.2s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
        circle.style.strokeDashoffset = offset;
    }

    function animateLabel(from, to, duration) {
        const start = performance.now();

        function tick(now) {
            const time = Math.min((now - start) / duration, 1);
            const ease = time < 0.5 ? 2*time*time : -1+(4-2*time)*time;
            label.textContent = Math.round(from + (to - from) * ease) + '%';
            if (time < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
    }

    function playIntro() {
        const reducedMotion = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;

        circleChart.classList.remove('visible');
        circle.style.transition = 'none';
        circle.style.strokeDashoffset = circumference;
        label.textContent = '0%';

        if (reducedMotion) {
            setProgress(percentage, false);
            label.textContent = percentage + '%';
            circleChart.classList.add('visible');

        } else {
            requestAnimationFrame(() => requestAnimationFrame(() => {

                setProgress(percentage, true);

                setTimeout(() => {
                    circleChart.classList.add('visible');
                    animateLabel(0, percentage, 1000);
                }, 200);

            }));
        }

    }

    // Observe when circleChart enters viewport
    const pieCharts = new IntersectionObserver((entries) => {

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                playIntro();
                pieCharts.unobserve(circleChart); // Only animate once
            }
        });

    }, { 
        threshold: 0.3 // trigger when 30% of the element is visible
    });

    pieCharts.observe(circleChart);
}

// Init pie charts on the page
document.querySelectorAll('.statistics-item.pie-chart [data-percent]').forEach(initChart);

// BAR CHART ANIMATION

const prefersReducedMotion = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion) {
const barCharts = new IntersectionObserver((bars) => {
    bars.forEach(bar => {

        if (bar.isIntersecting) {
            bar.target.classList.add('is-visible');
            barCharts.unobserve(bar.target); // animate once only
        }

    });
}, {
    threshold: 0.2 // trigger when 20% of the element is visible
});

document.querySelectorAll('.statistics-item.bar-chart .bar-chart-item-bar').forEach(el => {
  barCharts.observe(el);
});
} else {
    document.querySelectorAll('.statistics-item.bar-chart .bar-chart-item-bar').forEach(el => {
        el.classList.add('is-visible');
    });
}